import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BookCall() {
  const navigate = useNavigate();
  const buttonRef = useRef(null);

  useEffect(() => {
    const button = buttonRef.current;

    const handleMouseMove = (e) => {
      const rect = button.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      button.style.setProperty("--x", `${x}px`);
      button.style.setProperty("--y", `${y}px`);
    };

    button.addEventListener("mousemove", handleMouseMove);
    return () => {
      button.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const buttonStyle = {
    position: "relative",
    appearance: "none",
    backgroundColor: "#f72359",
    padding: "1em 2em",
    border: "none",
    color: "white",
    fontSize: "1.2em",
    cursor: "pointer",
    outline: "none",
    overflow: "hidden",
    borderRadius: "100px",
  };

  const beforeStyle = {
    content: '""',
    position: "absolute",
    left: "var(--x)",
    top: "var(--y)",
    width: "var(--size)",
    height: "var(--size)",
    background: "radial-gradient(circle closest-side, #4405f7, transparent)",
    transform: "translate(-50%, -50%)",
    transition: "width 0.2s ease, height 0.2s ease",
    zIndex: 0,
  };

  const handleMouseEnter = () => {
    buttonRef.current.style.setProperty("--size", "400px");
  };

  const handleMouseLeave = () => {
    buttonRef.current.style.setProperty("--size", "0px");
  };

  return (
    <div className="text-white text-center py-5" style={{ backgroundColor: "#5A7D9A" }}>
      <div className="container">
        <h3>Book a Free Consultation Call</h3>
        <p className="mb-4">
          Discuss your ideas or challenges with our experts. Let’s find the right solution together.
        </p>

        <button
          ref={buttonRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => navigate("/consult")}
          className="btn btn-lg d-inline-block"
          style={buttonStyle}
        >
          <span style={{ position: "relative", zIndex: 1 }}>Book Now</span>
          <span
            style={{
              ...beforeStyle,
              position: "absolute",
              pointerEvents: "none",
              left: "var(--x)",
              top: "var(--y)",
              width: "var(--size)",
              height: "var(--size)",
              background: "radial-gradient(circle closest-side, #4405f7, transparent)",
              transform: "translate(-50%, -50%)",
            }}
          ></span>
        </button>
      </div>
    </div>
  );
}
